module.exports = __webpack_public_path__ + "static/Screenshot (64)-9889528e045bf31f310c464d2f7cba4c.png";